import Cascader from './components/Cascader';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'cascader',
  pluginComponent: Cascader,
});
